// extracted by mini-css-extract-plugin
export default {"container":"Line_container__KOxcs","center":"Line_center__HXH+Y"};